import { useMemo } from 'react';
import { skipToken, useResource } from 'pulse/react';
import { GetRelevantThreadsForUserRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadViewRpc.resources';
import { useVisiblePollInterval } from '../hooks/useVisiblePollInterval';
import { sortThreadsByLatest } from '../utils/sortThreadsByLatest';
import { getIsPreview } from '../utils/isPreview';
import { getPreviewTicketThreads } from './previewMocks';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const getRelevantThreadsParams = ticketId => ({
  accountId: getPortalAccountId(),
  portalInstanceId: getPortalInstanceId(),
  params: {
    ticketId
  }
});
export const useTicketThreads = (ticketId, options) => {
  const {
    isPreview
  } = getIsPreview();
  const pollInterval = useVisiblePollInterval(options !== null && options !== void 0 && options.shouldPoll ? 10000 : undefined);
  const {
    data,
    loading,
    error
  } = useResource(GetRelevantThreadsForUserRpc, {
    params: isPreview || !ticketId ? skipToken : getRelevantThreadsParams(ticketId),
    pollInterval
  });
  const threads = useMemo(() => {
    var _data$data;
    if (isPreview) {
      return getPreviewTicketThreads(ticketId).threads;
    }
    return ((_data$data = data === null || data === void 0 ? void 0 : data.data) !== null && _data$data !== void 0 ? _data$data : []).map(thread => {
      var _thread$latestMessage;
      return {
        threadId: thread.threadId,
        startedAt: thread.startedAt,
        latestMessageTimestamp: (_thread$latestMessage = thread.latestMessageTimestamp) !== null && _thread$latestMessage !== void 0 ? _thread$latestMessage : thread.startedAt,
        originalChannel: typeof thread.originalChannel === 'string' ? thread.originalChannel : null
      };
    });
  }, [data, isPreview, ticketId]);
  const latestThread = useMemo(() => {
    if (threads.length === 0) {
      return null;
    }
    return sortThreadsByLatest(threads)[0];
  }, [threads]);
  return {
    threads,
    latestThread,
    loading: isPreview ? false : loading && !data,
    error
  };
};